import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { http, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, KeyRound } from "lucide-react";

export default function ChangePasswordDialog({ open, onClose }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) {
      toast.error("Les deux mots de passe ne correspondent pas");
      return;
    }
    if (next.length < 6) {
      toast.error("6 caractères minimum");
      return;
    }
    setSaving(true);
    try {
      await http.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Mot de passe mis à jour");
      setCurrent(""); setNext(""); setConfirm("");
      onClose();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2"><KeyRound className="h-5 w-5" /> Changer mon mot de passe</DialogTitle>
          <DialogDescription>Choisissez un mot de passe personnel et confidentiel.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-2">
          <div className="space-y-1.5">
            <Label className="text-xs uppercase tracking-widest font-semibold text-slate-500">Mot de passe actuel</Label>
            <Input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required className="h-11" data-testid="cp-current" autoComplete="current-password" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs uppercase tracking-widest font-semibold text-slate-500">Nouveau mot de passe</Label>
            <Input type="password" value={next} onChange={(e) => setNext(e.target.value)} required minLength={6} className="h-11" data-testid="cp-new" autoComplete="new-password" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs uppercase tracking-widest font-semibold text-slate-500">Confirmer</Label>
            <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={6} className="h-11" data-testid="cp-confirm" autoComplete="new-password" />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>Annuler</Button>
            <Button type="submit" disabled={saving} data-testid="cp-submit" className="gap-2">
              {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
              Mettre à jour
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
